module.exports = __webpack_public_path__ + "static/media/snd.97a3ced6.webp";